
import { Component, Vue } from "vue-property-decorator";
import { OrderRecordService, UpateOrderInput } from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { __param } from "tslib";
import AdvertisingDialog from "./components/advertisingDialog.vue";

@Component({
    name: "advertisingSpace",
    components: {
        AdvertisingDialog,
    },
})
export default class AdvertisingSpace extends Vue {
    private orderRecordService = new OrderRecordService();

    private isLoading = false;
    isTableLoading = false;
    isTableLoadingTable = false;
    schoolId: number;
    schoolName = "";
    advertisingList: any = [];
    getpage(): void {
        // this.getOrderRecordRegistration()
    }
    created() {
        this.schoolId = Number(this.$route.params["id"]);
        this.schoolName = this.$route.params["schoolName"];
        this.getAdvertisingSpace();
        this.indexMethod;
    }
    success() {
        this.getAdvertisingSpace();
    }
    indexMethod(index) {
        return index + 1;
    }
    handleSelectionChange(val) {
        // console.log("sdfasdasdf22+:"+val.id)
        // this.viewDetail(val.id)
    }
    // 上移
    upMove(rowid, isUp) {
      console.log(44444)
        var aa = new UpateOrderInput({
        id : rowid,
        isUp: isUp
      })
      console.log(aa)
      this.orderRecordService.updateAdvertisingSpaceOrder(aa)
      .then(()=>{
        this.$message.success("排序成功")
        this.getAdvertisingSpace();
      })
      .catch(() => {
         this.$message.success("排序失败")
      })
    }
    // 下移
    moveDown(list, index) {
        if (index != list.length - 1) {
            list[index].sortNumber = index + 1;
            list[index + 1].sortNumber = index;
            list[index] = list.splice(index + 1, 1, list[index])[0];
        }
    }
    deleteAdvertising(id) {
        console.log("ssss");
        this.$confirm("确认删除吗?")
            .then(async () => {
                this.isTableLoading = true;
                this.orderRecordService
                    .deleteAdvertisingSpace(id)
                    .then(() => {
                        this.$notify.success("删除成功");
                    })
                    .finally(() => {
                        this.isTableLoading = false;
                        this.getAdvertisingSpace();
                    });
            })
            .catch(() => {})
            .finally(() => {
                this.isTableLoading = false;
            });
    }

    //获取列表
    getAdvertisingSpace() {
        this.isTableLoading = true;
        this.orderRecordService
            .getAdvertisingSpace(this.schoolId)
            .then((result) => {
                this.advertisingList = result.advertisingSpaces;
                console.log(result);
            })
            .finally(() => {
                this.isTableLoading = false;
            });
    }

    //返回
    backMajior() {
        this.$router.push({ name: "unicomRegistration",params: {navType:'second'} })
        
    }

    //打开新增 编辑弹框
    advertisingSettings(type, id, coverUrl, jumpAddress) {
        console.log(
            "type" + type,
            "id" + id,
            "coverUrl" + coverUrl,
            "地址" + jumpAddress
        );

        (this.$refs.advertisingRef as AdvertisingDialog).open(
            type == 0 ? 0 : id,
            this.schoolId,
            type,
            coverUrl,
            jumpAddress,
            this.schoolName
        );
    }
}
